/**
 * @param {Element | null | undefined} element
 * @param {ScrollIntoViewOptions} [options]
 */
export function scrollElementIntoView(
  element,
  options = { behavior: 'smooth', block: 'start' },
) {
  if (!element || typeof element.scrollIntoView !== 'function') {
    return;
  }
  element.scrollIntoView(options);
}
